import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Button,
  Row,
  Col,
} from "reactstrap";
import CoreEngine from "../../core/CoreEngine";
import RequestEngine from "../../core/RequestEngine";
import { connect } from "react-redux";
import loadingAction from "../../core/redux/actions/loadingAction";
import ReactTable from "react-table";
import TablePagination from "components/Table/TablePagination";
import strings from "../../core/translate";
import RowActions, {
  editAction,
  deleteAction,
} from "components/Table/RowActions";
import SelectRow from "../../components/Select/SelectRow";
import { Scopes } from "../../shared/scopes.enum";
import GarageSectionHeader from "../../components/Garage/GarageSectionHeader";
import { FormModal } from "../../components/Form/FormKit";
import AppointmentSettingsForm from "./AppointmentSettingsForm";

class MerchantBranchAppointmentSettingsList extends CoreEngine {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      dataSource: [],
      merchants: [],
      branches: [],
      selectedMerchant: "",
      selectedBranch: "",
      branchName: "",
      garageScoped: false,
      formOpen: false,
      editing: null,
      globalFilter: "",
      startDateFilter: null,
      endDateFilter: null,
      canWrite: false,
    };
    this.engine = new RequestEngine();
  }

  componentDidMount() {
    const merchantIdFromStorage = sessionStorage.getItem("merchantId");
    const canWrite = this.hasPermission([
      Scopes.MERCHANTS_BRANCHES_APPOINTMENTS_SETTINGS_WRITE,
    ]);
    this.setState({ canWrite });

    // Set the selectedMerchant directly from sessionStorage or fetch merchants list
    if (merchantIdFromStorage) {
      this.setState(
        { selectedMerchant: merchantIdFromStorage, canWrite },
        () => {
          this.fetchbranches();
          this.callPage();
        }
      );
    } else {
      this.fetchmerchants();
    }

    const routeState = this.props.location.state || {};
    const { selectedBranch } = this.props.match.params;
    // opened from a garage record, so the garage is fixed for this page
    if (selectedBranch && selectedBranch !== ":selectedBranch") {
      this.setState(
        {
          selectedBranch,
          garageScoped: true,
          branchName: routeState.branchName || "",
          selectedMerchant:
            merchantIdFromStorage || routeState.selectedMerchant || "",
        },
        () => {
          if (this.state.selectedMerchant && !merchantIdFromStorage) {
            this.fetchbranches();
          }
          this.callPage();
        }
      );
    }
  }

  fetchmerchants = async () => {
    const response = await this.engine.getItem("merchants");
    if (response && response.status === 200) {
      this.setState({
        isLoading: false,
        merchants: response.data.items.map((merchant) => ({
          value: merchant.id,
          label: merchant.name,
        })),
      });
    }
  };

  async fetchbranches() {
    const { selectedMerchant, selectedBranch } = this.state;
    if (!selectedMerchant) return;
    const response = await this.engine.getItem(
      `merchants/${selectedMerchant}/branches`
    );
    if (response && response.status === 200) {
      const branches = response.data.items.map((branch) => ({
        value: branch.id,
        label: branch.name || branch.address,
      }));
      const match = branches.find((branch) => branch.value === selectedBranch);
      this.setState((prev) => ({
        isLoading: false,
        branches,
        branchName: prev.branchName || (match ? match.label : ""),
        selectedBranch:
          selectedBranch === ":selectedBranch" ? "" : prev.selectedBranch,
      }));
    }
  }

  async callPage() {
    const { selectedBranch } = this.state;
    if (!selectedBranch || selectedBranch === ":selectedBranch") return;

    const pathname = `merchants-branches/${selectedBranch}/appointments-settings`;
    const response = await this.engine.getItem(pathname);
    if (response && response.status === 200) {
      this.setState({
        isLoading: false,
        dataSource: response.data.items.map((item, key) => ({
          id: key,
          data: item,
          workingHours: item.workingHours,
          breakTime: item.breakTime,
          workingDays: item.workingDays,
          appointmentsFrequency: item.appointmentsFrequency,
          appointmentsPerSlot: item.appointmentsPerSlot,
          slotBookingThreshold: item.slotBookingThreshold,
          created: new Date(item.createdAt),
          actions: this.handleActions(key, item),
        })),
      });
    }
    this.props.loadingAction(false);
  }

  handlePage() {
    this.props.loadingAction(true);
    this.callPage();
  }

  async handleDelete(valueid) {
    if (window.confirm(strings.confirmdelete)) {
      this.props.loadingAction(true);
      const { selectedBranch } = this.state;
      const result = await this.engine.deleteItem(
        `merchants-branches/${selectedBranch}/appointments-settings`,
        valueid
      );
      if (result) {
        this.handlePage();
      }
      this.props.loadingAction(false);
    }
  }

  handleActions(index, item) {
    return (
      <RowActions
        actions={[
          editAction(() => this.handleEdit(index, item.id), this.state.canWrite),
          deleteAction(() => this.handleDelete(item.id), this.state.canWrite),
        ]}
      />
    );
  }
  handlemerchantselect(event) {
    const selectedMerchant = event.value;

    if (selectedMerchant !== this.state.selectedMerchant)
      this.setState(
        { selectedMerchant, selectedBranch: "", branches: [], dataSource: [] },
        () => {
          this.fetchbranches(); // Fetch branches for the selected merchant
        }
      );
  }

  handlebrancheselect(event) {
    const selectedBranch = event.value;
    this.setState({ selectedBranch }, () => {
      this.props.history.push(
        `/admin/merchants-branches/${selectedBranch}/appointments-settings`
      );
      this.callPage(); // Fetch services for the selected branch
    });
  }

  // add and edit open the same dialog over the list
  handleAdd = () => {
    const { selectedBranch } = this.state;

    if (!selectedBranch || selectedBranch === ":selectedBranch") {
      alert(strings.select + " " + strings.garage);
      return;
    }
    this.setState({ formOpen: true, editing: null });
  };

  handleEdit(index) {
    this.setState({
      formOpen: true,
      editing: this.state.dataSource[index].data,
    });
  }

  handleCloseForm = () => this.setState({ formOpen: false, editing: null });

  handleSaved = () => {
    this.setState({ formOpen: false, editing: null }, this.handlePage);
  };

  render() {
    const {
      dataSource,
      isLoading,
      merchants,
      branches,
      selectedMerchant,
      selectedBranch,
      branchName,
      garageScoped,
      formOpen,
      editing,
      canWrite,
    } = this.state;

    let columns = [
      { Header: strings.workinghours, accessor: "workingHours" },
      { Header: strings.workingdays, accessor: "workingDays" },
      { Header: strings.breaktime, accessor: "breakTime" },
      {
        Header: strings.appointmentsfrequency,
        accessor: "appointmentsFrequency",
      },
      { Header: strings.appointmentsperslot, accessor: "appointmentsPerSlot" },
      {
        Header: strings.slotbookingthreshold,
        accessor: "slotBookingThreshold",
      },
      {
        Header: strings.created,
        accessor: "created",
        Cell: (row) => row.value.toLocaleDateString(),
      },
      {
        Header: strings.actions,
        accessor: "actions",
        sortable: false,
        filterable: false,
      },
    ];

    return (
      <>
        <div className="content">
          <GarageSectionHeader
            branchId={garageScoped ? selectedBranch : ""}
            branchName={branchName}
            merchantId={selectedMerchant}
            active="appointment-settings"
            history={this.props.history}
          />
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <CardTitle tag="h4" className="pull-left">
                    {garageScoped ? strings.appointment_settings : ""}
                  </CardTitle>
                  {canWrite && (
                    <Button
                      color="primary"
                      className="pull-right"
                      onClick={() => this.handleAdd()}
                    >
                      {strings.add}
                    </Button>
                  )}
                  {!garageScoped && !sessionStorage.getItem("merchantId") && (
                    <SelectRow
                      label={strings.merchant}
                      name="selectedMerchant"
                      defaultValue={selectedMerchant}
                      data={merchants}
                      changeInput={(e) => this.handlemerchantselect(e)}
                      placeholder={strings.select}
                    />
                  )}
                  {!garageScoped && (
                    <SelectRow
                      key={selectedMerchant || "default"}
                      label={strings.garage}
                      name="selectedBranch"
                      defaultValue={selectedBranch}
                      data={branches}
                      changeInput={(e) => this.handlebrancheselect(e)}
                      placeholder={strings.select}
                      viewonly={!selectedMerchant}
                    />
                  )}
                </CardHeader>
                <CardBody>
                  <ReactTable
                    previousText={strings.previous}
                    nextText={strings.next}
                    loadingText={strings.loading}
                    noDataText={strings.nodata}
                    pageText={strings.page}
                    data={dataSource}
                    defaultFilterMethod={this.filterCaseInsensitive}
                    filterable
                    loading={isLoading}
                    columns={columns}
                    defaultPageSize={10}
                    showPaginationTop={false}
                    showPaginationBottom
                    PaginationComponent={TablePagination}
                    className="-striped -highlight primary-pagination"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>

          <FormModal
            isOpen={formOpen}
            onClose={this.handleCloseForm}
            icon="nc-icon nc-settings-gear-65"
            title={
              editing
                ? `${strings.edit} ${strings.appointment_settings}`
                : `${strings.add} ${strings.appointment_settings}`
            }
            subtitle={branchName}
          >
            <AppointmentSettingsForm
              key={(editing && editing.id) || "new"}
              item={editing}
              branchId={selectedBranch}
              onSaved={this.handleSaved}
              onCancel={this.handleCloseForm}
            />
          </FormModal>
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  loadingAction: (payload) => dispatch(loadingAction(payload)),
});
export default connect(
  null,
  mapDispatchToProps
)(MerchantBranchAppointmentSettingsList);
